export type PasswordCheck = {
  id: 'length' | 'upper-lower' | 'number' | 'special';
  valid: boolean;
};

export const getPasswordChecks = (value: string): PasswordCheck[] => [
  { id: 'length', valid: value.length >= 8 },
  { id: 'upper-lower', valid: /[A-Z]/.test(value) && /[a-z]/.test(value) },
  { id: 'number', valid: /\d/.test(value) },
  { id: 'special', valid: /[^A-Za-z0-9]/.test(value) },
];

export const isStrongPassword = (value: string): boolean =>
  getPasswordChecks(value).every((item) => item.valid);
